// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h2[data-v-a5cae528]{font-family:\"Tiempos Fine\",serif;padding-top:20px;font-size:7rem}@media only screen and (max-width: 1903px){h2[data-v-a5cae528]{font-size:6rem}}@media only screen and (max-width: 959px){h2[data-v-a5cae528]{font-size:5rem}}@media only screen and (max-width: 599px){h2[data-v-a5cae528]{font-size:4rem}}", ""]);
// Exports
module.exports = exports;
